// @react/hooks/useTask.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskStore } from '@core/stores';

/**
 * React hook for Task operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTask } from '@react/hooks';
 *
 * const TaskList = observer(() => {
 *   const store = useTask();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTask() {
  return taskStore;
}
